module.exports = __webpack_public_path__ + "media/images/icon-productivity-52636d5ea18d4dcfbaae8c025429a4ea.png";